/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SimpleDataRequestResource } from './SimpleDataRequestResource';
import {
    SimpleDataRequestResourceFromJSON,
    SimpleDataRequestResourceFromJSONTyped,
    SimpleDataRequestResourceToJSON,
    SimpleDataRequestResourceToJSONTyped,
} from './SimpleDataRequestResource';
import type { Resolution } from './Resolution';
import {
    ResolutionFromJSON,
    ResolutionFromJSONTyped,
    ResolutionToJSON,
    ResolutionToJSONTyped,
} from './Resolution';

/**
 * 
 * @export
 * @interface PieDataRequest
 */
export interface PieDataRequest {
    /**
     * 
     * @type {number}
     * @memberof PieDataRequest
     */
    timeFrom: number;
    /**
     * 
     * @type {number}
     * @memberof PieDataRequest
     */
    timeTo: number;
    /**
     * 
     * @type {Resolution}
     * @memberof PieDataRequest
     */
    resolution: Resolution;
    /**
     * 
     * @type {string}
     * @memberof PieDataRequest
     */
    metricKey: string;
    /**
     * 
     * @type {number}
     * @memberof PieDataRequest
     */
    threshold?: number;
    /**
     * 
     * @type {Array<SimpleDataRequestResource>}
     * @memberof PieDataRequest
     */
    resources: Array<SimpleDataRequestResource>;
}



/**
 * Check if a given object implements the PieDataRequest interface.
 */
export function instanceOfPieDataRequest(value: object): value is PieDataRequest {
    if (!('timeFrom' in value) || value['timeFrom'] === undefined) return false;
    if (!('timeTo' in value) || value['timeTo'] === undefined) return false;
    if (!('resolution' in value) || value['resolution'] === undefined) return false;
    if (!('metricKey' in value) || value['metricKey'] === undefined) return false;
    if (!('resources' in value) || value['resources'] === undefined) return false;
    return true;
}

export function PieDataRequestFromJSON(json: any): PieDataRequest {
    return PieDataRequestFromJSONTyped(json, false);
}

export function PieDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PieDataRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'timeFrom': json['timeFrom'],
        'timeTo': json['timeTo'],
        'resolution': ResolutionFromJSON(json['resolution']),
        'metricKey': json['metricKey'],
        'threshold': json['threshold'] == null ? undefined : json['threshold'],
        'resources': ((json['resources'] as Array<any>).map(SimpleDataRequestResourceFromJSON)),
    };
}

export function PieDataRequestToJSON(json: any): PieDataRequest {
    return PieDataRequestToJSONTyped(json, false);
}

export function PieDataRequestToJSONTyped(value?: PieDataRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timeFrom': value['timeFrom'],
        'timeTo': value['timeTo'],
        'resolution': ResolutionToJSON(value['resolution']),
        'metricKey': value['metricKey'],
        'threshold': value['threshold'],
        'resources': ((value['resources'] as Array<any>).map(SimpleDataRequestResourceToJSON)),
    };
}

